import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="home--search"
export default class extends Controller {
  getStarted() {
    const input = document.querySelector(".aa-Input");
    window.location.href = `/search?by_address=${encodeURIComponent(input.value)}`;
  }
}
